import { Pipe, PipeTransform } from '@angular/core';
import { Navigation } from '@apply4u/shared/constant/navigation/navigation';
import { FormatSeoUrl } from '@apply4u/shared/helpers/seo-helper';
import { IsNotNullOrEmpty, IsNotZeroNumber } from '../helpers/common/type-safe-helpers';

@Pipe({
    name: 'JobSearchDetailUrlPipe',
    standalone: true
})
export class JobSearchDetailPipe implements PipeTransform {

    transform(value: string, location?: string, jobId?: number): any {
        let jobDetailUrl = "";

        if (IsNotNullOrEmpty(value)) {
            jobDetailUrl = value.trim() + "-jobs";
        }

        if (IsNotNullOrEmpty(location)) {
            jobDetailUrl = jobDetailUrl + "-in-" + location.trim();
        }

        if (IsNotNullOrEmpty(jobDetailUrl)) {
            jobDetailUrl = (Navigation.JobSearch + "/" + FormatSeoUrl(jobDetailUrl)).toLowerCase();
        }

        if (IsNotZeroNumber(jobId)) {
            if (IsNotNullOrEmpty(jobDetailUrl)) {
                jobDetailUrl = (jobDetailUrl + "/" + jobId);
            }
        }

        return jobDetailUrl;
    }

}
